import styled from 'styled-components'

import { Card as DefaultCard } from '@/components/ui/card'

export const StyledCard = styled(DefaultCard)<{ $isLoading: boolean }>(({ theme, $isLoading }) => ({
  alignItems: 'flex-start',
  flex: 'initial',
  flexDirection: 'row',
  gap: theme.space['8'],
  height: 'auto',
  minHeight: 'fit-content',
  opacity: $isLoading ? 0.5 : 1,
  padding: `${theme.space['16']} ${theme.space['24']}`,
  pointerEvents: $isLoading ? 'none' : 'auto',
  transition: `opacity ${theme.transition.duration.sm} ease`,
}))

export const MetricCard = styled.div(({ theme }) => ({
  '&:not(:last-of-type)': {
    borderRight: `${theme.border.size['1']} solid ${theme.colors.gray200}`,
    paddingRight: theme.space['8'],
  },
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: theme.space['4'],
}))

export const ValueWithUnit = styled.div(({ theme }) => ({
  alignItems: 'baseline',
  display: 'flex',
  gap: theme.space['2'],
}))
